import React, { FunctionComponent } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Main } from './components/Main';
import ConsentToGA from './cookies/cookies';
const App: FunctionComponent = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Header />
            <Main />
            <Footer />
            <ConsentToGA />
        </ThemeProvider>
    );
};

export default App;
